export enum CountdownActionsEnum {
  nothing = 'nothing',
  redirection = 'redirection',
}
